import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ChevronUpDown({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M5.65988 5.75C5.49682 5.74994 5.33676 5.71269 5.19646 5.64216C5.05615 5.57162 4.94073 5.47039 4.86228 5.34904C4.78383 5.22769 4.74521 5.09067 4.75047 4.95232C4.75574 4.81397 4.80468 4.67936 4.89219 4.56255L7.4817 1.10788C7.56392 0.998207 7.6774 0.907911 7.81165 0.845354C7.94589 0.782797 8.09656 0.75 8.2497 0.75C8.40284 0.75 8.5535 0.782797 8.68775 0.845354C8.82199 0.907911 8.93547 0.998207 9.01769 1.10788L11.6078 4.56255C11.6953 4.67939 11.7443 4.81405 11.7495 4.95245C11.7548 5.09085 11.7161 5.2279 11.6376 5.34926C11.559 5.47063 11.4435 5.57185 11.3032 5.64235C11.1628 5.71285 11.0026 5.75003 10.8395 5.75H5.65988Z"
        fill="currentColor"
      />
      <path
        d="M10.8401 9.25C11.0032 9.25006 11.1632 9.28731 11.3035 9.35784C11.4439 9.42838 11.5593 9.52961 11.6377 9.65096C11.7162 9.77231 11.7548 9.90933 11.7495 10.0477C11.7443 10.186 11.6953 10.3206 11.6078 10.4374L9.0183 13.8921C8.93608 14.0018 8.8226 14.0921 8.68835 14.1546C8.55411 14.2172 8.40344 14.25 8.2503 14.25C8.09716 14.25 7.9465 14.2172 7.81225 14.1546C7.67801 14.0921 7.56453 14.0018 7.48231 13.8921L4.89219 10.4374C4.80465 10.3206 4.75571 10.1859 4.75047 10.0476C4.74523 9.90915 4.7839 9.7721 4.86243 9.65074C4.94095 9.52937 5.05645 9.42815 5.19685 9.35765C5.33724 9.28715 5.49737 9.24997 5.66049 9.25H10.8401Z"
        fill="currentColor"
      />
    </svg>
  )
}
